import { useCallback } from 'react';

export const useRESTFetcher = () => {

  const koiFetch = useCallback(
    async (input: RequestInfo, init?: RequestInit) => {
      const res = await fetch(input, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        ...init,
      });

      // if (res.status === 400) {
      //   navigate({ to: `/${MainRoute.Error400}`, replace: true });
      // }

      return res.json();
    },
    []
  );
  return { koiFetch };
};
